import React from 'react';
import {useTranslation} from 'react-i18next';
import FormikTextField from 'components/inputs/FormikTextField';
import Dialog from 'components/Dialog';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import Formik from 'components/hook-form/Formik';

type AddSshHostKeyDialogProps = {
   open: boolean;
   onAdd: () => void;
   onCancel: () => void;
};

const AddSshHostKeyDialog = ({open, onAdd, onCancel}: AddSshHostKeyDialogProps) => {
   const {t} = useTranslation();
   const {request} = usePostApi(api.sshHostkeys);
   const onSuccess = () => {
      onAdd();
      onCancel();
   };
   const handleSubmit = (values: {hostname: string; fingerprint: string}) => {
      request(JSON.stringify(values), {onSuccess});
   };
   return (
      <Dialog maxWidth="sm" open={open} header={t('Add SSH Host Key')} close={onCancel}>
         <Formik initialValues={{hostname: '', fingerprint: ''}} onSubmit={handleSubmit}>
            <>
               <FormikTextField label={t('Host address')} name={'hostname'} />
               <FormikTextField label={t('Fingerprint')} name={'fingerprint'} />
               <FormFooterButtons cancel={onCancel} />
            </>
         </Formik>
      </Dialog>
   );
};

export default AddSshHostKeyDialog;
